import { basePostAPICall, getAPICall, postAPICall, putAPICall } from './BaseAPI';

export const getTrackersData = async (cb = (jR, s, e) => { }) => {
  return await getAPICall('trackingtags/gettrackersdata/', cb);
}

export const getReservationsByTrackingId = async (trackingId, cb = (jR, s, e) => { }) => {
  if (!trackingId) {
    throw new Error('trackingId is required');
  }
  return await getAPICall(`trackingtags/reservations/${trackingId}`, cb);
};

export const getTrackersWithActiveReservationData = async (cb = (jR, s, e) => { }) => {
  return await getAPICall('trackingtags/gettrackerswithactivereservationdata/', cb);
}